import * as React from 'react';
import Typography from '@material-ui/core/Typography';

export const SectionDescription: React.SFC = (props) => {
  return <Typography style={{ marginBottom: 16 }}>{props.children}</Typography>;
};
